import { Link } from "react-router-dom";
import { Heart, ImageOff } from "lucide-react";
import { imageUrl, formatINR, BEAUTY_CAT } from "@/lib/lamka";

export const ProductCard = ({ item, index, onToggleLike }) => {
  const img = imageUrl(item.images?.[0]);
  const tag = item.category === BEAUTY_CAT ? "Beauty" : "Fashion";
  return (
    <article
      data-testid={`product-card-${item.id}`}
      className="group fade-up min-w-0"
      style={{ animationDelay: `${Math.min(index, 12) * 50}ms` }}
    >
      <div className={`relative ${item.category === BEAUTY_CAT ? "aspect-square" : "aspect-[3/4]"} overflow-hidden bg-[#F5EFE6]`}>
        {img ? (
          <Link to={`/product/${item.id}`} data-testid={`product-link-${item.id}`} className="block h-full w-full">
            <img src={img} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </Link>
        ) : (
          <Link to={`/product/${item.id}`} className="h-full w-full flex items-center justify-center text-[#C5A059]"><ImageOff className="h-8 w-8" strokeWidth={1} /></Link>
        )}
        <span data-testid="product-category-tag" className="absolute top-3 left-3 bg-[#0F0F0F]/85 text-[#C5A059] font-mono text-[10px] uppercase tracking-[0.2em] px-2.5 py-1">
          {tag}
        </span>
        <button
          data-testid={`like-button-${item.id}`}
          aria-label={item.is_liked ? "Remove from wishlist" : "Save to wishlist"}
          aria-pressed={!!item.is_liked}
          onClick={() => onToggleLike(item)}
          className="absolute top-3 right-3 h-9 w-9 flex items-center justify-center rounded-full bg-[#0F0F0F]/70 backdrop-blur-sm text-white transition-[transform,background-color] duration-200 hover:bg-[#0F0F0F] hover:scale-110 active:scale-90"
        >
          <Heart className={`h-4 w-4 transition-colors ${item.is_liked ? "fill-[#C5A059] text-[#C5A059]" : ""}`} strokeWidth={1.5} />
        </button>
        {item.followed && (
          <span data-testid="product-followed-tag" className="absolute bottom-3 right-3 bg-[#C5A059] text-[#0F0F0F] font-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1">Following</span>
        )}
        {item.stock === 0 && (
          <span className="absolute bottom-3 left-3 bg-white/90 text-[#0F0F0F] font-mono text-[10px] uppercase tracking-[0.2em] px-2.5 py-1">Sold out</span>
        )}
      </div>
      <div className="pt-4 space-y-1.5">
        <Link to={`/seller/${item.seller_id}`} data-testid="product-seller" className="block font-mono text-[10px] uppercase tracking-[0.22em] text-[#71717A] truncate hover:text-[#B38F46] transition-colors">{item.seller_name || "Lamka seller"}</Link>
        <Link to={`/product/${item.id}`}><h3 data-testid="product-title" className="font-display text-lg leading-snug text-[#0F0F0F] line-clamp-2 group-hover:text-[#B38F46] transition-colors">{item.title}</h3></Link>
        <div className="flex items-center justify-between gap-2 pt-1">
          <p data-testid="product-price" className="font-mono text-sm text-[#0F0F0F] min-w-0 truncate">{formatINR(item.price)}</p>
          <span data-testid="product-likes" className="shrink-0 flex items-center gap-1 text-xs text-[#71717A]">
            <Heart className={`h-3.5 w-3.5 ${item.is_liked ? "fill-[#C5A059] text-[#C5A059]" : ""}`} strokeWidth={1.5} /> {item.likes_count || 0}
          </span>
        </div>
      </div>
    </article>
  );
};
